// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ee","articleImagesWrap":"fe","articleImage":"ge","singleImage":"he"};